/*
 * Bundle entry point. esbuild compiles this to dist/js/app.js.
 *
 * Every component is a no-op unless its markup is on the page, so this list
 * can stay as-is for the life of the project — delete an import only when you
 * have removed the component from the template for good.
 */
import $ from "./lib/jquery.js";

import initForms from "./components/form.js";
import initFormSlider from "./components/form-slider.js";
import initGalleryFader from "./components/gallery-fader.js";
import initGoogleMap from "./components/google-map.js";
import initInteractiveMap from "./components/interactive-map.js";
import initRecaptcha from "./components/recaptcha.js";

import { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor } from "./lib/dom.js";

/*
 * Layout helpers that page-level inline scripts still call by name.
 * Reach for CSS grid or flexbox first — these are for the awkward cases.
 */
Object.assign(window, { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor });

function init() {
  initRecaptcha();
  initForms();
  initFormSlider();
  initGalleryFader();
  initInteractiveMap();
  initGoogleMap();

  /*
   * sliders() before animation(), deliberately. slick's `infinite` mode
   * clones slides to fill the loop, and those clones are copies of markup
   * that carries `data-aos` (component-text-block.php puts it on its
   * wrapper). AOS collects [data-aos] once, inside AOS.init(), so anything
   * cloned after that is never in its store, never gets `.aos-animate`, and
   * stays at the opacity: 0 aos.css sets on it — the image renders and the
   * text block is invisible. Building the sliders first means the clones
   * already exist when AOS goes looking.
   */
  sliders();
  animation();

  document.querySelectorAll(".scroller").forEach((el) => {
    el.addEventListener("click", () => scrollToAnchor(el.dataset.scrollpos));
  });
}

/*
 * Wait for ready, never run on the spot. header.php loads this bundle with
 * `defer`, so by the time it executes readyState is already "interactive" —
 * running immediately would beat any deferred script that comes after it in
 * header.php, and a jQuery plugin loaded that way would not be registered yet.
 * Deferred scripts all run before DOMContentLoaded, so waiting for it is what
 * makes the ordering in header.php mean what it looks like it means.
 */
$(init);

function animation(){


    // Animate on scroll init
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: true, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      // disable: 'mobile',
    });

    /*
     * refreshHard, not refresh: refresh() only recalculates offsets against
     * the elements AOS already knows about, so it cannot pick up markup that
     * appeared after init (slick clones, anything injected later). This is
     * the belt to the ordering above's braces.
     */
    setTimeout(function() {
        AOS.refreshHard();
    }, 500);
}

$(window).on('resize orientationchange', function() {
    $('.slider-basic').slick('resize');
});

function sliders(){
    if($('.slider-basic').length){
        $('.slider-basic').slick({
            autoplay: true,
            infinite: true,
            fade: true,
            speed: 1000,
            cssEase: 'linear',
            arrows: false,
            dots: false,
        });
    }
}
